import { useFormikContext } from 'formik'

import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { useAuthentication } from '@hooks/useAuthentication'
import { ConsentType } from '@models/consent/ConsentType'
import { WriterFormType } from '@models/writer/WriterFormType'
import { WriterStatusEnum } from '@interfaces/WriterStatusEnum'
import { ConsentAcceptProps, ConsentProps } from './interface'

export function withConsent(Component: React.FC<ConsentProps>) {
  function WithConsent({ status, ...props }: ConsentAcceptProps) {
    const { user } = useAuthentication()
    const termsOfServiceModal = useModal({ modal: 'writerTermsOfService' })
    const { values, setFieldValue } = useFormikContext<WriterFormType>()

    function onApprove() {
      setFieldValue('consents[0].checked', true)
      termsOfServiceModal.hide()
    }

    function openTermsOfServiceModal({ id, name, content }: ConsentType) {
      const consent = user?.writerRequest?.writersConsents?.find(
        item => item.consent.id === id
      )
      termsOfServiceModal.show({
        title: name,
        content,
        submittedDate: consent?.createdAt || '',
        showApproveAction: status !== WriterStatusEnum.APPROVED,
        onApprove,
      })
    }

    const componentProps = {
      ...props,
      checked: values.consents[0].checked,
      openTermsOfServiceModal,
    }
    return <Component {...componentProps} />
  }

  return WithConsent
}
